if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart = document.querySelector('mini-cart');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText =
          this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }

        this.hideErrors =
          this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          this.submitButton.getAttribute('aria-disabled') ===
          'true'
        ) {
          return;
        }

        if (!this.blockSubmitIfRequiredFieldsEmpty(evt)) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );
        this.submitButton.classList.add('loading');

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] =
          'XMLHttpRequest';

        const formData = new FormData(this.form);

        const directSendAddon =
          this.form.querySelector('direct-send-addon');

        const directSendItems =
          directSendAddon?.isSelected
            ? directSendAddon.buildCartItems(formData)
            : null;

        if (
          directSendAddon?.isSelected &&
          !directSendItems
        ) {
          this.submitButton.removeAttribute(
            'aria-disabled'
          );
          this.submitButton.classList.remove('loading');
          return;
        }

        const sections = this.cart
          ? this.cart
              .getSectionsToRender()
              .map((section) => section.id)
          : [];

        if (this.cart) {
          this.cart.setActiveElement(
            document.activeElement
          );
        }

        if (directSendItems) {
          config.headers['Content-Type'] =
            'application/json';

          config.body = JSON.stringify({
            items: directSendItems,
            sections: sections,
            sections_url: window.location.pathname
          });
        } else {
          delete config.headers['Content-Type'];

          if (this.cart) {
            formData.append('sections', sections);
            formData.append(
              'sections_url',
              window.location.pathname
            );
          }

          config.body = formData;
        }

        fetch(theme.routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors:
                  response.errors ||
                  response.description,
                message: response.message
              });

              this.handleErrorMessage(
                response.description
              );

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (!soldOutMessage) return;

              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );

              this.submitButtonText.classList.add(
                'hidden'
              );

              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (!this.cart) {
              window.location = theme.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cart: response
              });
            }

            this.error = false;

            const quickAddModal =
              this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );

              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.submitButton.classList.remove(
              'loading'
            );

            if (
              this.cart &&
              this.cart.classList.contains('is-empty')
            ) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) {
              this.submitButton.removeAttribute(
                'aria-disabled'
              );
            }
          });
      }

      blockSubmitIfRequiredFieldsEmpty(event) {
        if (!(this.form instanceof HTMLFormElement)) {
          throw new Error(
            'Expected a form element.'
          );
        }

        const formId = this.form.getAttribute('id');

        const requiredFields =
          document.querySelectorAll('[required]');

        let allFilled = true;

        for (const field of requiredFields) {
          const belongsToForm =
            field.getAttribute('form') === formId ||
            field.closest('form')?.id === formId;

          if (!belongsToForm) continue;

          let isValid = true;

          switch (field.type) {
            case 'checkbox':
            case 'radio': {
              const group =
                document.querySelectorAll(
                  `input[name="${field.name}"][type="${field.type}"]`
                );

              isValid = Array.from(group).some(
                (input) => input.checked
              );

              break;
            }

            case 'select-one':
              isValid = field.value !== '';
              break;

            case 'textarea':
            case 'text':
            case 'email':
            case 'number':
            case 'url':
            default:
              isValid = field.value.trim() !== '';
              break;
          }

          if (!isValid) {
            allFilled = false;
            field.classList.add('invalid');
          } else {
            field.classList.remove('invalid');
          }
        }

        if (!allFilled) {
          event.preventDefault();

          this.handleErrorMessage(
            theme.accessibilityStrings
              .fillInAllLineItemPropertyRequiredFields
          );

          return false;
        }

        return true;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (text) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute(
            'disabled'
          );

          this.submitButtonText.textContent =
            theme.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}